<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="title">ACKNOWLEDGMENTS</h1>
<p class="p"><span>This book became a reality thanks to the dedication and assistance of many people, principle among them Dr. H. Dewey DeWitt, professor emeritus and Westminster College archivist. He led the dig through mountains of documents and photographs, a treasure hunt that resulted in the images included here. Thanks also go to Molly Spinney, librarian, who supported our work and continues to cherish the college’s records, photographs, and ephemera. We also are indebted to college historian Paul W. Gamble, whose earlier histories informed our research and contributed valued perspective.</span></p>
<p class="p-indent"><span>Importantly, we are grateful to Tom Williamson, Westminster’s 13th president and a man of great character with a great love for the college. His foreword provides insight into our college’s past and its future.</span></p>
<p class="p-indent"><span>Dorothy Pollock, Darwin Huey, Gloria Cagigas, Sue Rudloff, Mark Meighan, Sandra Chandler, Justin Zackel, Keith McCauley, Bill Foster, Jim Giel, and many others offered advice and guidance. What’s more, they opened their files and shared countless stories and photographs.</span></p>
<p class="p-indent"><span>It is impossible, in 128 pages, to capture the breadth of Westminster’s history. We hope that we have included photographs that represent shared memories, favorite events, and significant places.</span></p>
<p class="p-indent"><span>Works cited in the book include: <em class="i">The History of New Wilmington, Pennsylvania 1797–2003: The Story of a Small Town</em>, edited by H. Dewey DeWitt, Paul W. Gamble, Delber L. McKee, Eugene G. Sharkey, and Alan G. Sternbergh in 2004; <em class="i">The Westminster Story, 1852–2002, Glorious, Grand and True</em>, by Paul W. Gamble and Richard H. Gamble in 2002; <em class="i">History of Westminster College, 1852–1992</em>, by Paul W. Gamble in 1992; and <em class="i">When Titans Truly Were: Westminster College and the Second World War</em>, by Eugene G. Sharkey.</span></p>
<p class="p-indent"><span>All royalties from this book benefit McGill Memorial Library.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack01.vue?7ab98224